// extracted by mini-css-extract-plugin
export default {"saved-list__table-structure":"saved-list__table-structure_vSUdUJd3","no_results__message":"no_results__message_eHT7aPDT"};